/**
 * Central API configuration. The frontend talks to rsv-api/v3 only.
 * Legacy endpoints (tkts.rsvapp.com/update, etc.) are off-limits.
 */
export const apiConfig = {
  baseUrl: (import.meta.env.VITE_API_BASE_URL || 'https://api.rsv.mx/v3').replace(/\/$/, ''),
  legacyCdn: import.meta.env.VITE_LEGACY_CDN || 'https://cdn.rsvapp.com',
  appName: import.meta.env.VITE_APP_NAME || 'GuestRise Tickets',
  appDomain: import.meta.env.VITE_APP_DOMAIN || 'tickets.guestrise.com',
  features: {
    offline: import.meta.env.VITE_FEATURE_OFFLINE === 'true',
    walletPasses: import.meta.env.VITE_FEATURE_WALLET_PASSES === 'true',
  },
} as const;
